import { defaultTaxReturnState } from './module-taxreturn-state';

export default {
	resetState(state) {
		Object.assign(state, defaultTaxReturnState);
	},
	updateTaxReturnTypeData: function(state, data) {
		if (data) {
			state.TaxReturnTypeData = data;
		}
	}
};
